import script from "./YzIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./YzIndex.vue?vue&type=script&setup=true&lang=js"

import "./YzIndex.vue?vue&type=style&index=0&id=5fa911d4&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5fa911d4"]])

export default __exports__